import api from 'api';
import type { UserCustomAttribute } from 'shared-types';
import type { UserAttributesAttributeFormState } from 'components/admin/settings/userAttributes/UserAttributesAttributeForm';

const updateAttributeRequiredPasswords = async (
  updatedRequiredPasswords: UserAttributesAttributeFormState['validation']['requiredPasswords'],
  previousRequiredPasswords?: NonNullable<
    UserCustomAttribute['validation']
  >['requiredPasswords']
) => {
  // handle new passwords
  for (const updatedPassword of updatedRequiredPasswords) {
    const previousPassword = previousRequiredPasswords?.find(
      (previousPassword) =>
        previousPassword.passwordIdentifier ===
        updatedPassword.passwordIdentifier
    );
    if (previousPassword) continue;

    await api.put('/admin/server-config/api-keys', {
      keyName: updatedPassword.passwordIdentifier,
      keyValue: updatedPassword.passwordValue
    });
  }
};

export default updateAttributeRequiredPasswords;
